<template>
  <div class="content">
    <v-row class="search_box">
      <v-col>
        <topNav></topNav>
      </v-col>
    </v-row>
    <div class="main_container">
      <div class="md_title mart24 marb12">分类统计</div>
      <div style="margin-left: -25px; margin-top: -15px">
        <v-breadcrumbs :items="items">
          <template v-slot:divider>
            <v-icon>mdi-chevron-right</v-icon>
          </template>
        </v-breadcrumbs>
      </div>
      <v-row>
        <v-col>
          <div class="firm_list_wrapper martop14">
            <div class="firm_list_top">
              <v-tabs
                mart24
                padTop
                :class="{ tab_detail1: true, custom_style3: !isPhone }"
                @change="handleChange"
                v-model="activeKey"
              >
                <v-tab key="1"> <i class="icon base"></i>专利信息 </v-tab>
                <v-tab key="2"> <i class="icon summary"></i>商标信息 </v-tab>
                <v-tab key="3"> <i class="icon rights"></i>著作权 </v-tab>
                <v-tab key="4"> <i class="icon desp"></i>资质认证 </v-tab>
                <v-tab key="5"> <i class="icon fimg"></i>标准制定 </v-tab>
                <v-tab-item key="1">
                  <div class="content_tabitem_wrapper">
                    <div class="top_box_wrapper">
                      <div class="top_box2">
                        <div class="item_wrapper">
                          <div class="three_item_box">
                            <!-- <div
                              class="item_box first"
                            >
                              <div :class="left_icon[index]"></div>
                              <div class="right_text hand"     
                              v-for="(item, index) in listout"
                              :key="index">
                                <span class="num">{{ item.num}}</span>
                                <div class="text">{{ item.name }}</div>
                              </div>
                              <div class="line"></div>
                            </div> -->
                            <div class="item_box first">
                              <div class="left_icon valid_icon"></div>
                              <div class="right_text hand">
                                <span
                                  class="num"
                                  v-if="listout[0] && listout[0].num"
                                  >{{ listout[0].num }}</span
                                >
                                <span class="num" v-else>0</span>
                                <div
                                  v-if="listout[0] && listout[0].name"
                                  class="text"
                                >
                                  {{ listout[0].name }}
                                </div>
                                <!-- <div  v-else class="text">发明公开</div> -->
                              </div>
                              <div class="line"></div>
                            </div>
                            <div class="item_box second">
                              <div class="left_icon apply_icon"></div>
                              <div class="right_text hand">
                                <span
                                  class="num"
                                  v-if="listout[1] && listout[1].num"
                                  >{{ listout[1].num }}</span
                                >
                                <span class="num" v-else>0</span>
                                <div
                                  v-if="listout[1] && listout[1].name"
                                  class="text"
                                >
                                  {{ listout[1].name }}
                                </div>
                                <!-- <div  v-else class="text">发明授权</div> -->
                              </div>
                              <div class="line"></div>
                            </div>

                            <div class="item_box third">
                              <div class="left_icon invalid_icon"></div>
                              <div class="right_text hand">
                                <span
                                  class="num"
                                  v-if="listout[2] && listout[2].num"
                                  >{{ listout[2].num }}</span
                                >
                                <span class="num" v-else>0</span>
                                <div
                                  v-if="listout[2] && listout[2].name"
                                  class="text"
                                >
                                  {{ listout[2].name }}
                                </div>
                                <!-- <div  v-else class="text">外观设计</div> -->
                              </div>
                              <div class="line"></div>
                            </div>
                            <div class="item_box four">
                              <div class="left_icon invalid_four"></div>
                              <div class="right_text hand">
                                <span
                                  class="num"
                                  v-if="listout[3] && listout[3].num"
                                  >{{ listout[3].num }}</span
                                >
                                <span class="num" v-else>0</span>
                                <div
                                  v-if="listout[3] && listout[3].name"
                                  class="text"
                                >
                                  {{ listout[3].name }}
                                </div>
                                <!-- <div  v-else class="text">实用新型</div> -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!------>
                  <div class="firm_list_center">
                    <v-data-table
                      v-model="selectKeys"
                      item-key="name"
                      :headers="headers"
                      :items="list"
                      class="common_table"
                      @click:row="rowClicktable"
                      :items-per-page="itemsPerPage"
                      hide-default-footer
                    >
                      <template v-slot:[`header.type`]="{ header }">
                        <!-- <div> -->
                        <div>
                          {{ header.text }}
                          <v-col class="d-flex" cols="12" sm="12">
                            <v-select
                              :items="sortList"
                              label=""
                              v-model="sortKey"
                              @change="changeType"
                              item-text="label"
                              item-value="value"
                              :dense="true"
                              solo
                              class="tabType"
                            >
                            </v-select>
                          </v-col>
                        </div>
                        <!-- </div> -->
                      </template>
                      <template v-slot:[`item.type`]="{ item }">
                        <span style="margin-left: 28px">{{ item.type }}</span>
                      </template>
                      <template v-slot:[`item.option`]="{ item }">
                        <div style="max-width: 230px" class="actions_text">
                          <div
                            class="know_img"
                            @click="zhishiCompany(item.documentNumber)"
                          ></div>
                        </div>
                      </template>
                    </v-data-table>
                    <!---第一个分页-->
                    <div class="hist_pagination">
                      <v-row>
                        <v-col class="common_pagePase left">
                          <v-pagination
                            v-model="currentPage"
                            :length="pageLength"
                            :total-visible="pageVisible"
                          >
                          </v-pagination>
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                </v-tab-item>
                <v-tab-item key="2">
                  <div class="content_tabitem_wrapper">
                    <div class="top_box_wrapper">
                      <div class="top_box2">
                        <div class="item_wrapper">
                          <div class="three_item_box">
                            <!-- <div
                              class="item_box2 first"
                              v-for="(item, index) in tmOutline"
                              :key="index"
                            >
                              <div :class="left_icon_tm[index]"></div>
                              <div class="right_text hand">
                                <span class="num">{{ item.num }}</span>
                                <div class="text">{{ item.name }}</div>
                              </div>
                              <div class="line"></div>
                            </div> -->
                            <div class="item_box first">
                              <div class="left_icon valid_pa"></div>
                              <div class="right_text hand">
                                <span
                                  class="num"
                                  v-if="tmOutline[0] && tmOutline[0].num"
                                  >{{ tmOutline[0].num }}</span
                                >
                                <span class="num" v-else>0</span>
                                <div
                                  v-if="tmOutline[0] && tmOutline[0].name"
                                  class="text"
                                >
                                  {{ tmOutline[0].name }}
                                </div>
                                <!-- <div   v-else class="text">申请总量</div> -->
                              </div>
                              <div class="line"></div>
                            </div>
                            <div class="item_box second">
                              <div class="left_icon apply_pa"></div>
                              <div class="right_text hand">
                                <span
                                  class="num"
                                  v-if="tmOutline[1] && tmOutline[1].num"
                                  >{{ tmOutline[1].num }}</span
                                >
                                <span class="num" v-else>0</span>
                                <div
                                  v-if="tmOutline[1] && tmOutline[1].name"
                                  class="text"
                                >
                                  {{ tmOutline[1].name }}
                                </div>
                                <!-- <div   v-else class="text">注册总数</div> -->
                              </div>
                              <div class="line"></div>
                            </div>
                            <div class="item_box third">
                              <div class="left_icon invalid_pa"></div>
                              <div class="right_text hand">
                                <span
                                  class="num"
                                  v-if="tmOutline[2] && tmOutline[2].num"
                                  >{{ tmOutline[2].num }}</span
                                >
                                <span class="num" v-else>0</span>
                                <div
                                  v-if="tmOutline[2] && tmOutline[2].name"
                                  class="text"
                                >
                                  {{ tmOutline[2].name }}
                                </div>
                                <!-- <div   v-else class="text">有效总数</div> -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="firm_list_center">
                    <v-data-table
                      v-model="selectKeys"
                      item-key="id"
                      :headers="headers2"
                      :items="list2"
                      class="common_table"
                      :items-per-page="itemsPerPage"
                      hide-default-footer
                    >
                    </v-data-table>
                    <!---商标分页-->
                    <div class="hist_pagination">
                      <v-row>
                        <v-col class="common_pagePase left">
                          <v-pagination
                            v-model="currentPageOne"
                            :length="pageLength_tm"
                            :total-visible="pageVisible"
                          >
                          </v-pagination>
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                </v-tab-item>
                <v-tab-item key="3">
                  <div class="firm_list_center">
                    <v-data-table
                      v-model="selectKeys"
                      item-key="id"
                      :headers="headers3"
                      :items="list3"
                      class="common_table"
                      :items-per-page="itemsPerPage"
                      hide-default-footer
                    >
                    </v-data-table>
                    <!--著作分页-->
                    <div class="hist_pagination">
                      <v-row>
                        <v-col class="common_pagePase left">
                          <v-pagination
                            v-model="currentPageTwo"
                            :length="pageLength"
                            :total-visible="pageVisible"
                          >
                          </v-pagination>
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                </v-tab-item>
                <v-tab-item key="4">
                  <div class="firm_list_center">
                    <v-data-table
                      v-model="selectKeys"
                      item-key="id"
                      :headers="headers4"
                      :items="list4"
                      class="common_table"
                      :items-per-page="itemsPerPage"
                      hide-default-footer
                    >
                    </v-data-table>
                    <!---资质认证分页-->
                    <div class="hist_pagination">
                      <v-row>
                        <v-col class="common_pagePase left">
                          <v-pagination
                            v-model="currentPageThree"
                            :length="pageLength_three"
                            :total-visible="pageVisible"
                          >
                          </v-pagination>
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                </v-tab-item>
                <v-tab-item key="5">
                  <div class="content_tabitem_wrapper">
                    <div class="top_box_wrapper">
                      <div class="top_box2">
                        <div class="item_wrapper">
                          <div class="three_item_box">
                            <!-- 
                         <div class="item_box first"  
                              v-for="(item,index) in stdoutline"
                                :key="index" >
                              <div :class="left_icon_std[index]"></div>
                              <div class="right_text hand">
                                <span
                                  class="num"
                                  >{{ item.num }}</span
                                >
                                <div class="text">{{item.name}}</div>
                              </div>
                              <div class="line"></div>
                            </div>  -->

                            <div class="item_box first">
                              <div class="left_icon valid_std01"></div>
                              <div class="right_text hand">
                                <span
                                  class="num"
                                  v-if="stdoutline[0] && stdoutline[0].num"
                                  >{{ stdoutline[0].num }}</span
                                >
                                <span class="num" v-else>0</span>
                                <div
                                  v-if="stdoutline[0] && stdoutline[0].name"
                                  class="text"
                                >
                                  {{ stdoutline[0].name }}
                                </div>
                                <!-- <div   class="text" v-else >国家标准</div> -->
                              </div>
                              <div class="line"></div>
                            </div>
                            <div class="item_box second">
                              <div class="left_icon valid_std02"></div>
                              <div class="right_text hand">
                                <span
                                  class="num"
                                  v-if="stdoutline[1] && stdoutline[1].num"
                                  >{{ stdoutline[1].num }}</span
                                >
                                <span class="num" v-else>0</span>
                                <div
                                  v-if="stdoutline[1] && stdoutline[1].name"
                                  class="text"
                                >
                                  {{ stdoutline[1].name }}
                                </div>
                                <!-- <div class="text" v-else >行业标准</div> -->
                              </div>
                              <div class="line"></div>
                            </div>
                            <div class="item_box third">
                              <div class="left_icon valid_std03"></div>
                              <div class="right_text hand">
                                <span
                                  class="num"
                                  v-if="stdoutline[2] && stdoutline[2].num"
                                  >{{ stdoutline[2].num }}</span
                                >
                                <span class="num" v-else>0</span>
                                <div
                                  v-if="stdoutline[2] && stdoutline[2].name"
                                  class="text"
                                >
                                  {{ stdoutline[2].name }}
                                </div>
                                <!-- <div class="text" v-else >团体标准</div> -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="firm_list_center">
                    <!-- <v-data-table
                      v-model="selectKeys"
                      item-key="id"
                      :headers="headers5"
                      :items="list5"
                      class="common_table"
                      :items-per-page="itemsPerPage"
                      hide-default-footer
                    >
                    </v-data-table> -->

                    <v-data-table
                      v-model="selectKeys"
                      item-key="id"
                      :headers="headers5"
                      :items="list5"
                      class="common_table"
                      :items-per-page="itemsPerPage"
                      hide-default-footer
                    >
                    </v-data-table>
                    <!---标准制定分页-->
                    <div class="hist_pagination">
                      <v-row>
                        <v-col class="common_pagePase left">
                          <v-pagination
                            v-model="currentPageFive"
                            :length="pageLength_std"
                            :total-visible="pageVisible"
                          >
                          </v-pagination>
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                </v-tab-item>
              </v-tabs>
              <!------->
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
    <!---pdf的弹窗-->
    <v-dialog v-model="visible" width="80%">
      <div class="pdf_wrapper">
        <v-card>
          <v-card-title
            >PDF全文
            <v-icon @click="visible = false">mdi-close</v-icon>
          </v-card-title>
          <v-card-text>
            <div style="height: 100%">
              <embed
                :src="src"
                type="application/pdf"
                width="100%"
                height="100%"
              />
            </div>
          </v-card-text>
          <v-divider></v-divider>
        </v-card>
      </div>
    </v-dialog>
  </div>
</template>
<script>
import topNav from "@/components/widgets/topNav.vue";
import companyList from "../../assets/company.json";
import { mapActions } from "vuex";
import Qs from "qs";
export default {
  data() {
    return {
      left_icon: ["valid_01", "valid_02", "valid_03", "valid_04"],
      left_icon_tm: ["valid_tm01", "valid_tm02", "valid_tm03", "valid_tm04"],
      left_icon_std: [
        "valid_std01",
        "valid_std02",
        "valid_std03",
        "valid_std04",
      ],
      onShow: true,
      offShow: false,
      activeIndex: "1",
      title: "",
      items: [
        {
          text: "返回",
          disabled: false,
          href: "/#/category",
        },

        {
          text: this.$route.query.name,
          disabled: false,
        },
      ],
      currentPageOne: 1,
      currentPageTwo: 1,
      currentPageThree: 1,
      currentPageFive: 1,
      visible: "",
      src: "",
      page: 1, //当前页面号
      itemsPerPage: 15, //每页条目数
      pageLength: 0, //总页面数
      pageLengthTwo: 0,
      pageLength_tm: 0, //商标
      pageLength_std: 0, //标准制定
      pageLength_three: 0, //资质认证
      pageVisible: 7,
      detailVisible: false,
      isPhone: false,
      activeKey: "1",
      sort: "desc",
      length: 0,
      sort1: "desc",
      sort2: "desc",
      sort3: "desc",
      sort4: "desc",
      sort5: "desc",
      list: [
        {
          type: "",
        },
      ],
      selectKeys: [],
      addVisible: false,
      visibleTit: "添加企业",
      informationVisible: false, //工商信息
      itemsPerPageAllText: "",
      currentPage: 1,
      pageSize: 15,
      form: {},
      companyName: "",
      detailInfo2: "",
      name: "",
      id: "",
      keys: [
        "Name",
        "Calories",
        "Fat",
        "Carbs",
        "Protein",
        "Sodium",
        "Calcium",
        "Iron",
      ],
      itemsorts: [
        {
          name: "Frozen Yogurt",
          calories: 159,
          fat: 6.0,
          carbs: 24,
          protein: 4.0,
          sodium: 87,
          calcium: "14%",
          iron: "1%",
        },
      ],
      sortList: [
        { label: "所有类型", value: "" },
        { label: "发明授权", value: "invent_grant" },
        { label: "实用新型", value: "utility" },
        { label: "发明公开", value: "invent_application" },
        { label: "外观设计", value: "design" },
      ],
      sortKey: "",
      headers: [
        { text: "序号", value: "index", sortable: false },
        { text: "申请人", width: "16%", value: "applicants", sortable: false },
        {
          text: "申请号",
          width: "10%",
          value: "applicationNumber",
          sortable: false,
        },
        {
          text: "专利名称",
          value: "title",
          width: "16%",
          sortable: false,
        },
        { text: "", width: "20%", value: "type", sortable: false },
        { text: "专利状态", width: "10%", value: "status", sortable: false },
        {
          text: "申请日",
          width: "10%",
          value: "applicationDate",
          sortable: false,
        },
        {
          text: "公开日",
          width: "10%",
          value: "documentDate",
          sortable: false,
        },
        { text: "操作", value: "option", sortable: false },
      ],
      headers2: [
        { text: "商标名", value: "name", sortable: false },
        { text: "注册号", value: "registerNumber", sortable: false },
        { text: "申请日期", value: "applicationDate", sortable: false },
        { text: "商标类型", value: "type", sortable: false },
        { text: "法律状态", value: "status", sortable: false },
        { text: "注册地区", value: "country", sortable: false },
      ],
      list2: [],
      headers3: [
        { text: "序号", value: "index", sortable: false },
        { text: "软件名称", value: "fullName", sortable: false },
        { text: "登记号", value: "registerNumber", sortable: false },
        {
          text: "版本号",
          value: "version",
          sortable: false,
        },
        { text: "分类号", value: "type", sortable: false },
        { text: "登记批准日期", value: "approvalDate", sortable: false },
        { text: "软件简称", value: "simpleName", sortable: false },
      ],
      list3: [],
      headers4: [
        { text: "序号", value: "index", sortable: false },
        { text: "证书名称", value: "name", sortable: false },
        { text: "证书编号", value: "registerNumber", sortable: false },
        { text: "证书状态", value: "status", sortable: false },
        { text: "发证日期", value: "releaseDate", sortable: false },
      ],
      list4: [],
      headers5: [
        { text: "序号", value: "index", sortable: false },
        { text: "标准名称", value: "name", sortable: false },
        { text: "标准类型", value: "type", sortable: false },
        {
          text: "标准号",
          value: "contactPhone",
          sortable: false,
        },
        { text: "标准状态", value: "status", sortable: false },
        { text: "发布日期", value: "releaseDate", sortable: false },
      ],
      listout: [],
      tmOutline: [],
      stdoutline: [],
      tm_sumNum: "",
      publicNum: "",
      newTypeNum: "",
      designNum: "",
      list5: [],
      tm_sum: "",
      zhu_ce: "",
    };
  },
  computed: {},
  mounted() {
    this.getTrad_pa();
    let val = parseInt(this.$route.query.val);
    if (val === 1) {
      this.activeKey = 0;
      this.getTrad_pa();
    }
    if (val === 2) {
      this.activeKey = 1;
      this.getTrademark();
    }
    if (val === 3) {
      this.activeKey = 2;
      this.getknowTradeRzmark();
    }
    if (val === 4) {
      this.activeKey = 3;
      this.getTradeCert();
    }
    if (val === 5) {
      this.activeKey = 5;
      this.getTradeStd();
    }
  },

  components: {
    topNav,
  },
  created() {
    this.name = this.$route.query.name;
    this.id = this.$route.query.id;
    this.getTrad_pa();
    this.classMap = ["music", "story", "movie"];
  },
  watch: {
    currentPage() {
      this.getTrad_pa();
    },
    currentPageOne() {
      this.getTrademark();
    },
    currentPageTwo() {
      this.getknowTradeRzmark();
    },
    currentPageThree() {
      this.getTradeCert();
    }, //资质认证
    currentPageFive() {
      this.getTradeStd();
    },
    //选择类型
  },
  methods: {
    //列表的数据
    ...mapActions("manage", [
      "getCompanies",
      "getmanageUpdate",
      "getmanageManageAdd",
      "getmanageManageDelete",
      "getmanageManageSearch",
      "getmanaGemanagePatent",
      "getmanageCompanyindex",
    ]),
    ...mapActions("search", ["querySearch", "getPatentPdf"]),
    zhishiCompany(val) {
      this.viewId = val;
      this.visible = true;
      this.getPdf();
    },
    getPdf(type) {
      // let id = this.viewId;
      // if (type == "1") {
      //   id = this.id;
      // }
      // if (type == "2") {
      //   id = this.id1;
      // }
      // if (type == "3") {
      //   id = this.doubleId;
      // }
      let documentNumber = this.viewId;
      let data = {
        params: {
          // udn: id,
          udn: documentNumber,
        },
      };
      let _this = this;
      this.getPatentPdf({
        data: data,
        handle(res) {
          _this.src1 = res.pdf.pdfPath;
          _this.src = _this.$store.state.baseUrl + res.pdf.pdfPath;
          if (type == "1") {
            _this.src2 = _this.$store.state.baseUrl + res.pdf.pdfPath;
          }
          if (type == "2") {
            _this.src3 = _this.$store.state.baseUrl + res.pdf.pdfPath;
          }
        },
      });
    },
    //table的切换的按钮
    handleChange(val) {
      console.log(val, "=====val==");
      if (val == 0) {
        this.currentPage = 1;
        this.getTrad_pa();
      }
      if (val == 1) {
        this.currentPageOne = 1;
        this.getTrademark();
      }
      if (val == 2) {
        this.currentPageTwo = 1;
        this.getknowTradeRzmark();
      }
      if (val == 3) {
        this.currentPageThree = 1;

        this.getTradeCert();
      }
      if (val == 4) {
        this.currentPageFive = 1;
        this.getTradeStd();
      }
    },
    //选择类型
    changeType(val) {
        console.log(val, "=====val==");
        this.getTrad_pa();
      if (val == "invent_grant") {
        this.currentPage = 1;
      }
      if (val == 'utility') {
        this.currentPage = 1;
      }
      if (val =='invent_application') {
        this.currentPage = 1;
      }
      if (val =='design') {
        this.currentPage = 1;
      }
     
    },
    //第一个列表的页面
    rowClicktable: function (item, row) {
      row.select(true);
      let codes = this.list.map((item) => {
        return item.name;
      });
      let value = codes.join(" OR ");
      let temp = "ap:( " + item.name + " )";
      this.$router.push({
        // path: "/search/result",
        query: {
          str: temp,
        },
      });
    },
    //列表的数据
    ...mapActions("manage", [
      "getCompanies",
      "getmanageUpdate",
      "getmanageManageAdd",
      "getmanageManageDelete",
      "getmanageManageSearch",
      "getmanageCompanyindex",
    ]),
    ...mapActions("knowledge", [
      "getknowTradPa",
      "getknowTrademark",
      "getknowTradeRz",
      "getknowTradeCert",
      "getknowTradeStd",
    ]),
    //专利的信息
    getTrad_pa() {
      let _this = this;
      let data = {
        params: {
          companyId: this.id,
          page: this.currentPage,
          pageSize: 15,
          sortField: "pa_ad",
          sortDirection: "asc",
          type: this.sortKey,
        },
      };
      this.getknowTradPa({
        data: data,
        handle(res) {
          let list = res.message.data;
          _this.list = res.message.data;
          _this.listout = res.message.outline;
          _this.pageLength = parseInt(res.message.pages);
        },
      });
    },

    
    //商标信息
    getTrademark() {
      let _this = this;
      let data = {
        params: {
          companyId: this.id,
          page: this.currentPageOne,
          pageSize: 15,
          sortField: "tm_ad",
          sortDirection: "asc",
          type: this.sortKey,
        },
      };
      this.getknowTrademark({
        data: data,
        handle(res) {
          let list = res.message.data;
          _this.list2 = res.message.data;
          _this.tmOutline = res.message.outline;
          _this.pageLength_tm = parseInt(res.message.pages);
        },
      });
    },
    //著作信息
    getknowTradeRzmark() {
      let _this = this;
      let data = {
        params: {
          companyId: this.id,
          page: this.currentPageTwo,
          pageSize: 15,
          sortField: "rz_aprv_date",
          sortDirection: "asc",
          type: this.sortKey,
        },
      };
      this.getknowTradeRz({
        data: data,
        handle(res) {
          let list = res.message.data;
          _this.list3 = res.message.data;
          _this.pageLength = parseInt(res.message.pages);
        },
      });
    },
    //资质认证
    getTradeCert() {
      let _this = this;
      let data = {
        params: {
          companyId: this.id,
          page: this.currentPageThree,
          pageSize: 15,
          sortField: "cert_release_date",
          sortDirection: "asc",
          type: this.sortKey,
        },
      };
      this.getknowTradeCert({
        data: data,
        handle(res) {
          let list = res.message.data;
          _this.list4 = res.message.data;
          // _this.pageLength = parseInt(res.message.pages);
          _this.pageLength_three = parseInt(res.message.pages);
        },
      });
    },
    //标准制定
    getTradeStd() {
      let _this = this;
      let data = {
        params: {
          companyId: this.id,
          page: this.currentPageFive,
          pageSize: 15,
          sortField: "std_release_date",
          sortDirection: "asc",
          type: this.sortKey,
        },
      };
      this.getknowTradeStd({
        data: data,
        handle(res) {
          let list = res.message.data;
          _this.list5 = res.message.data;
          _this.pageLength_std = parseInt(res.message.pages);
          console.log(_this.pageLength_std, "===_this.pageLength_std====");
          _this.stdoutline = res.message.outline;
        },
      });
    },
    timeFormat(unixTime) {
      let date = new Date(unixTime);
      let Y = date.getFullYear() + "-";
      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      let D = date.getDate() + " ";
      let h = date.getHours() + ":";
      let m = date.getMinutes() + ":";
      let s = date.getSeconds();
      return Y + M + D + h + m + s;
    },

    successMsg(msg) {
      this.$message({
        type: "success",
        message: msg || "操作成功!",
      });
    },
    failMsg(msg) {
      this.$message({
        type: "error",
        message: msg || "操作失败!",
      });
    },
    //
    //搜索企业的名称
    getResult() {
      let _this = this;
      let data = {
        params: {
          names: this.companyName,
          page: this.currentPage,
          pageSize: this.pageSize,
        },
      };
      this.getmanageManageSearch({
        data: data,
        handle(res) {
          let list = res.message;
          _this.list = res.message.data;
          _this.pageLength = parseInt(res.message.pages);
        },
      });
    },
    addCompany() {
      this.form = {};
      this.addVisible = true;
      this.visibleTit = "添加企业";
    },
    editCompany(value) {
      this.addVisible = true;
      this.form = value;
      this.visibleTit = "修改企业";
    },
    //查看详情的功能
    detailsCompany(value) {
      this.detailVisible = true;
      this.form = value;
      this.visibleTit = "查看企业";
    },
    //详情的关闭
    handleDetailCancel() {
      this.detailVisible = false;
    },

    handleAddCancel() {
      this.addVisible = false;
    },
    async onPageChange(page) {
      this.page = page;
    },
    handleAddOk() {
      // this.addVisible = false
      let data = {
        params: this.form,
      };
      let _this = this;
      this.getmanageManageAdd({
        data: data,
        handle(res) {
          if (res.success) {
            _this.successMsg(res.message);
            _this.addVisible = false;
            // _this.getList();
          } else {
            _this.failMsg(res.message);
          }
        },
      });
    },
    handleEditOk() {
      let data = {
        params: {
          id: this.form.id,
          user: this.form.user,
          name: this.form.name,
          contact: this.form.contact,
          contactPhone: this.form.contactPhone,
          description: this.form.description,
        },
      };
      let _this = this;
      //编辑的接口
      this.getmanageUpdate({
        data: data,
        handle(res) {
          _this.addVisible = false;
          if (res.success) {
            _this.successMsg(res.message);
            // _this.getList();
          } else {
            _this.failMsg(res.message);
          }
        },
      });
    },
    //删除的table数据
    historyItemDel(id, val) {
      if (val == "list") {
        id = id.map((item) => {
          return item.id;
        });
      }
      let ids = id.join(",");
      this.$msgbox
        .confirm("此操作将永久删除该记录, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          let data = {
            params: {
              ids: ids,
            },
          };
          let _this = this;
          this.getmanageManageDelete({
            data: data,
            handle(res) {
              if (res.success) {
                _this.$message({
                  type: "success",
                  message: res.message || "操作成功",
                });
                // _this.getList();
              }
            },
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>